import memoizeOne from 'memoize-one';

const groupedValidations = memoizeOne(validations => validations.reduce(
  (objectsByKeyValue, obj) => ({
    ...objectsByKeyValue,
    [obj.validation]: (objectsByKeyValue[obj.validation] || []).concat(obj)
  }),
  {}
)); // group validations

const filterValidations = validations => Object.values(groupedValidations(validations))
  .map(group => group[0]); // get the latest validation by type

export default filterValidations;
